module.exports = __webpack_public_path__ + "static/media/kc_touch_water.3a876b9d.jpg";